import { render, staticRenderFns } from "./Stores.vue?vue&type=template&id=8878c5a8&scoped=true"
import script from "./Stores.vue?vue&type=script&lang=js"
export * from "./Stores.vue?vue&type=script&lang=js"
import style0 from "./Stores.vue?vue&type=style&index=0&id=8878c5a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8878c5a8",
  null
  
)

export default component.exports